//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.SelectCollisionSensor.js";
import "../no/SelectObject.js";
let d=[[[0,"Name",1,0],[1,"Sensor",0,"Mechatronics.SelectCollisionSensor",0]],[[[],"GetForm",{R_:{form:"Mechatronics.TagFormObject"}},0,0],[["form"],"SetForm",{},1,0],[[],"GetTable",{R_:{table:"Mechatronics.TagTableObject"}},0,0],[["table"],"SetTable",{},1,0],[[],"GetDeviceType",{R_:{type:''}},0,0],[["type"],"SetDeviceType",{},1,0],[[],"GetExecuteMode",{R_:{mode:''}},0,0],[["mode"],"SetExecuteMode",{},1,0]],[]];
SPLM.Mechatronics.ReadWriteDeviceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ReadWriteDeviceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ReadWriteDeviceBuilder.DeviceType = Object.freeze({
    "Reader" : "Reader", "Writer" : "Writer"});

SPLM.Mechatronics.ReadWriteDeviceBuilder.ExecuteMode = Object.freeze({
    "None" : "None", "Always" : "Always", "OnceOnly" : "OnceOnly"});

export default SPLM;